import { ComponentStyleConfig } from "@chakra-ui/react";
import { mode } from "@chakra-ui/theme-tools";

const Text: ComponentStyleConfig = {
  baseStyle: {
    whiteSpace: "pre-wrap",
    letterSpacing: "-0.02em",
  },

  variants: {
    body: (props) => ({
      fontSize: { base: "font-16" },
      color: mode("text-primary", "white")(props),
      lineHeight: "short",
      strong: {
        color: mode("text-primary", "white")(props),
      },
    }),

    "body-xl": {
      fontSize: "font-18",
      lineHeight: "base",
      fontWeight: "normal",
    },

    "body-lg-reg": {
      fontSize: "font-16",
      lineHeight: "base",
      fontWeight: "normal",
    },

    "body-lg-med": {
      fontSize: "font-16",
      lineHeight: "base",
      fontWeight: "medium",
    },

    "body-md-reg": {
      fontSize: "font-15",
      lineHeight: "base",
      fontWeight: "normal",
    },

    "body-md-med": {
      fontSize: "font-15",
      lineHeight: "base",
      fontWeight: "medium",
    },

    "body-sm-reg": {
      fontSize: "font-14",
      lineHeight: "base",
      fontWeight: "normal",
    },

    "body-sm-med": {
      fontSize: "font-14",
      lineHeight: "base",
      fontWeight: "medium",
    },

    "body-sm-semibold": {
      fontSize: "font-14",
      lineHeight: "base",
      fontWeight: "semibold",
    },

    "body-xs-reg": {
      fontSize: "font-12",
      lineHeight: "base",
      fontWeight: "normal",
    },

    "heading-5": {
      fontFamily: "heading",
      color: "text-heading",
      fontSize: {
        base: "font-18",
        lg: "font-24",
      },
      lineHeight: {
        lg: "34",
        base: "22",
      },
      letterSpacing: "-0.02em",
    },

    "body-small": (props) => ({
      fontSize: "font-15",
      color: mode("text-primary", "white")(props),
      lineHeight: { base: "base", lg: "shorter" },
      fontWeight: "normal",
      strong: {
        color: mode("text-primary", "white")(props),
      },
    }),
    cta: {
      fontSize: { base: "font-20" },
      fontWeight: "medium",
      lineHeight: "shorter",
    },
    subtitle: {
      fontFamily: "heading",
      fontSize: {
        base: "font-20",
        lg: "font-28",
      },
      color: "text-primary",
      lineHeight: {
        lg: "38",
        base: "25",
      },
      fontWeight: "normal",
      letterSpacing: "-0.02em",
    },
  },

  defaultProps: {},
};

export default Text;
